const metricManager = Owl.MetricManager();
const sendMetrics = {};

export function setExtraData(msg) {
  metricManager.setExtraData(msg);
}

export function setTags(name, value) {
  metricManager.setTags({ [name]: value });
}

export function setMetric(name, value = 1, once = true) {
  if (once && sendMetrics[name]) return;
  metricManager.setMetric(name, value);
  sendMetrics[name] = true;
}

export const METRICS = {
  ENTER_PAGE_HOST_ENV: 'enterPageHostEnv',
  HOST_ENV: 'hostEnv',
};
